import { oz } from '@weft/utils';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { GET_EVENT_FIELDS_PATH } from './get-event-fields-path';
import { GetEventFieldsResponseSchema } from './get-event-fields-response-schema';

export const EVENT_FIELDS_QUERY_PARAMETER = {
  name: 'eventName',
  location: 'query',
  schema: oz.string(),
  required: true,
} as const satisfies ZapiParam;

export const GET_EVENT_FIELDS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-event-fields',
  },
  queryParams: {
    [EVENT_FIELDS_QUERY_PARAMETER.name]: EVENT_FIELDS_QUERY_PARAMETER,
  },
  response: {
    name: 'GetEventFieldsResponse',
    schema: GetEventFieldsResponseSchema,
  },
  path: GET_EVENT_FIELDS_PATH,
} satisfies ZapiAction;

export type GetEventFieldsAction = typeof GET_EVENT_FIELDS_ACTION;